export { strings } from './strings'
